import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { ParadiseDetailsSection } from "src/components/Paradise/ParadiseDetailsLayout"
import { ParadiseTable } from "src/components/Paradise/ParadiseTable"
import { TParadiseShippableProduct } from "src/data/paradise/paradiseShippableProducts/paradiseShippableProductsTypes"
import {
  TableColumn,
  useTableColumns,
} from "src/ui/GridTable/useTableColumns/useTableColumns"

type TPricePerPlan = NonNullable<
  TParadiseShippableProduct["price_per_plan_type"]
>[number]

export function ParadiseShippableProductPriceSection({
  shippingProduct,
}: {
  shippingProduct: TParadiseShippableProduct
}) {
  const tableColumns: TableColumn<TPricePerPlan>[] = [
    {
      value: "plan",
      label: "Plan",
      renderCell: (data) => <div>{data.plan}</div>,
    },
    {
      value: "formatted_price",
      label: "Formatted Price",
      renderCell: (data) => <div>{data.price.formatted_amount}</div>,
    },
    {
      value: "raw_price",
      label: "Amount",
      renderCell: (data) => <div>{data.price.amount}</div>,
    },
  ]

  const { headerElements, rows, templateColumns } =
    useTableColumns<TPricePerPlan>({
      columns: tableColumns,
      data: shippingProduct.price_per_plan_type,
    })

  return (
    <Box>
      <div>
        <Text variant="bodyS" color="secondary" as="span">
          Default price (compare at price):{" "}
        </Text>
        <Text variant="subtitleS" as="span">
          {shippingProduct.compare_at_price.formatted_amount}
        </Text>
      </div>

      <ParadiseDetailsSection title="Price overrides">
        {(shippingProduct.price_per_plan_type ?? []).length > 0 ? (
          <ParadiseTable
            header={headerElements}
            rows={rows ?? []}
            templateColumns={templateColumns}
          />
        ) : (
          <Text variant="bodyS" color="secondary">
            No price overrides set for this product
          </Text>
        )}
      </ParadiseDetailsSection>
    </Box>
  )
}

const Box = styled.div`
  display: grid;
  gap: ${spacing.M};
`
